import { createStore } from "vuex";

import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import LanguageModule from "./modules/LanguageModule";
import TableModule from "./modules/TableModule";
import DataModule from "./modules/DataModule";
import DashboardModule from "./modules/DashboardModule";
import SearchModule from "./modules/SearchModule";

config.rawError = true;

const store = createStore({
  modules: {
    auth: AuthModule,
    body: BodyModule,
    breadcrumbs: BreadcrumbsModule,
    config: ConfigModule,
    language: LanguageModule,
    table: TableModule,
    data: DataModule,
    dashboard: DashboardModule,
    search: SearchModule
  }
});

export default store;
